import { render, staticRenderFns } from "./IssueSettlementManagement.vue?vue&type=template&id=0350b4a2&scoped=true"
import script from "./IssueSettlementManagement.vue?vue&type=script&lang=js"
export * from "./IssueSettlementManagement.vue?vue&type=script&lang=js"
import style0 from "./IssueSettlementManagement.vue?vue&type=style&index=0&id=0350b4a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0350b4a2",
  null
  
)

export default component.exports